module.exports = __webpack_public_path__ + "static/img/matriz-de-risco.70c68ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/apr/matriz-de-risco.png
// module id = bU2k
// module chunks = 0